"use client"

import { useEffect, useRef } from "react"
import "./ResetLinkSuccessPopup.css"

/**
 * Shared success popup when a password reset link is sent.
 * Used on Login (forgot password) and Settings/My Profile (send reset link).
 * - Heading from API response (e.g. message or code)
 * - Description: "A password reset link has been sent to {email}. Please check your inbox or spam folder."
 * - Auto-closes after autoCloseSeconds (default 5).
 */
export default function ResetLinkSuccessPopup({
  isVisible,
  onClose,
  heading = "Password reset link sent",
  email = "",
  autoCloseSeconds = 5,
}) {
  const timerRef = useRef(null)

  useEffect(() => {
    if (!isVisible || autoCloseSeconds <= 0) return
    timerRef.current = setTimeout(() => {
      onClose()
      timerRef.current = null
    }, autoCloseSeconds * 1000)
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
    }
  }, [isVisible, autoCloseSeconds, onClose])

  if (!isVisible) return null

  return (
    <>
      <div className="reset-link-popup-overlay" onClick={onClose} aria-hidden="true" />
      <div className="reset-link-popup-container">
        <div className="reset-link-popup-card" onClick={(e) => e.stopPropagation()}>
        <svg width="40" height="40" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.5 8.31039V9.00039C16.4991 10.6177 15.9754 12.1914 15.007 13.4868C14.0386 14.7821 12.6775 15.7297 11.1265 16.1883C9.57557 16.6469 7.91794 16.5918 6.40085 16.0313C4.88376 15.4708 3.58849 14.435 2.70822 13.0782C1.82795 11.7214 1.40984 10.1164 1.51626 8.50262C1.62267 6.88881 2.24791 5.35263 3.29871 4.12319C4.34951 2.89375 5.76959 2.03692 7.34714 1.6805C8.92469 1.32407 10.5752 1.48714 12.0525 2.14539" stroke="#34CC35" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M16.5 3L9 10.5075L6.75 8.2575" stroke="#34CC35" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <h2 className="reset-link-popup-title">{heading}</h2>
        <p className="reset-link-popup-subtitle">
          A password reset link has been sent to <span className="reset-link-email-highlight">{email}</span>. Please check your inbox or spam folder.
        </p>
        <button type="button" className="reset-link-popup-button" onClick={onClose}>
          Got it
        </button>
        </div>
      </div>
    </>
  )
}
